import { combineReducers } from "redux"
import { filterReducer } from "./filterReducer"
import usersReducer from "../reducer"
import { sponsoredProductReducer } from "../../modules/sponsoredProducts"
import { manyTargetCampaignsHistoryReducer } from "../../modules/manyTargetsCampaignsHistory"
import { projectReducer } from "../../modules/projects"
import { ProjectDataReducer } from "../../modules/projectDataAsin"
import { projectDataSettingsReducer } from "../../modules/ProjectDataSettings"
import { ProjectDataKeywordsReducer } from "../../modules/projectDataKewords"
import { ProjectDataRanksReducer } from "../../modules/projectDataRanks"
import {
  ProjectDataSQPByLastWeekReducer,
  ProjectDataSQPReducer,
} from "../../modules/ProjectDataSQP"
import { campaignsReducer } from "./campaignReducer"
import themeReducer from "../slices/themeSlice"
import { projectListReducer } from "./projectListReducer"
import {
  audiencesReducer,
  placementsReducer,
  sponsoredProductSKCReducer,
} from "../../modules/sponsoredProductsSKCAntd"
import { customersReducer } from "../../modules/customers"
import {
  sponsoredBrandsReducer,
  sponsoredBrandsTargetForTableReducer,
  sponsoredBrandsTargetReducer,
} from "../../modules/sponsoredBrands/store/reducers/sponsoredBrandsReducer"
import { sponsoredBrandsPlacementsReducer } from "../../modules/sponsoredBrands/store/reducers/sbPlacementsReducer"
import { searchTermsTrendsApi } from "../../modules/SearchTermsTrends/api/searchTermsTrends.api"

export const rootReducer = combineReducers({
  filter: filterReducer,
  data: usersReducer,
  sponsoredProducts: sponsoredProductReducer,
  history: manyTargetCampaignsHistoryReducer,
  projects: projectReducer,
  projectData: ProjectDataReducer,
  projectDataSettings: projectDataSettingsReducer,
  projectDataKeywords: ProjectDataKeywordsReducer,
  projectDataRanks: ProjectDataRanksReducer,
  projectDataSQP: ProjectDataSQPReducer,
  projectDataSQPByLastWeek: ProjectDataSQPByLastWeekReducer,
  campaigns: campaignsReducer,
  theme: themeReducer,
  projectsList: projectListReducer,
  placements: placementsReducer,
  sponsoredProductsSKC: sponsoredProductSKCReducer,
  audiences: audiencesReducer,
  customers: customersReducer,
  sponsoredBrands: sponsoredBrandsReducer,
  sponsoredBrandsTarget: sponsoredBrandsTargetReducer,
  sponsoredBrandsTargetForTable: sponsoredBrandsTargetForTableReducer,
  sponsoredBrandsPlacements: sponsoredBrandsPlacementsReducer,
  [searchTermsTrendsApi.reducerPath]: searchTermsTrendsApi.reducer,
})

export type RootState = ReturnType<typeof rootReducer>
